import Routes from '@expressive-analytics/vue-routes'
import r from "./routes.yml"
Routes.parseRoutes(r)

import "./components"

export default {
  name: "storm-theme-sidebar"
}
